export enum IDateFormat {
  DD_MM_YYYY_HH_MM_AMPM,
  DD_MM_YYYY,
  D_M_YYYY,
  DD_MM_YY,
  D_M_YY,
  MM_DD_YYYY,
  M_D_YYYY,
  MM_DD_YY,
  M_D_YY,
  D_M_YYYY_HH_MM_AMPM,
  DD_MM_YY_HH_MM_AMPM,
  D_M_YY_HH_MM_AMPM,
  MM_DD_YYYY_HH_MM_AMPM,
  M_D_YYYY_HH_MM_AMPM,
  MM_DD_YY_HH_MM_AMPM,
  M_D_YY_HH_MM_AMPM,
  DD_MM_YYYY_HH_MM,
  DATE_TIME,
  DATE_ONLY
}
export const IDateFormatLabels: Record<IDateFormat, string> = {
  [IDateFormat.D_M_YYYY_HH_MM_AMPM]: "D-M-YYYY",
  [IDateFormat.D_M_YYYY]: "D-M-YYYY",

  [IDateFormat.DD_MM_YY]: "DD-MM-YY",
  [IDateFormat.DD_MM_YY_HH_MM_AMPM]: "DD-MM-YY",

  [IDateFormat.D_M_YY]: "D-M-YY",
  [IDateFormat.D_M_YY_HH_MM_AMPM]: "D-M-YY",

  [IDateFormat.DD_MM_YYYY]: "DD-MM-YYYY",
  [IDateFormat.DD_MM_YYYY_HH_MM_AMPM]: "DD-MM-YYYY",

  [IDateFormat.MM_DD_YYYY]: "MM-DD-YYYY",
  [IDateFormat.MM_DD_YYYY_HH_MM_AMPM]: "MM-DD-YYYY",

  [IDateFormat.M_D_YYYY]: "M-D-YYYY",
  [IDateFormat.M_D_YYYY_HH_MM_AMPM]: "M-D-YYYY",

  [IDateFormat.MM_DD_YY]: "MM-DD-YY",
  [IDateFormat.MM_DD_YY_HH_MM_AMPM]: "MM-DD-YY",

  [IDateFormat.M_D_YY]: "M-D-YY",
  [IDateFormat.M_D_YY_HH_MM_AMPM]: "M-D-YY",

  [IDateFormat.DD_MM_YYYY_HH_MM]: "DD-MM-YYYY HH:MM",
  [IDateFormat.DATE_TIME]: "Date & Time",
  [IDateFormat.DATE_ONLY]: "Date Only"
};
// export const DateFormatOptions: Record<
//   IDateFormat,
//   Intl.DateTimeFormatOptions
// > = {
//   [IDateFormat.DD_MM_YYYY]: {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//   },
//   [IDateFormat.D_M_YYYY]: {
//     day: "numeric",
//     month: "numeric",
//     year: "numeric",
//   },
//   [IDateFormat.DD_MM_YY]: {
//     day: "2-digit",
//     month: "2-digit",
//     year: "2-digit",
//   },
//   [IDateFormat.D_M_YY]: {
//     day: "numeric",
//     month: "numeric",
//     year: "2-digit",
//   },
//   [IDateFormat.MM_DD_YYYY]: {
//     month: "2-digit",
//     day: "2-digit",
//     year: "numeric",
//   },
//   [IDateFormat.M_D_YYYY]: {
//     month: "numeric",
//     day: "numeric",
//     year: "numeric",
//   },
//   [IDateFormat.MM_DD_YY]: {
//     month: "2-digit",
//     day: "2-digit",
//     year: "2-digit",
//   },
//   [IDateFormat.M_D_YY]: {
//     month: "numeric",
//     day: "numeric",
//     year: "2-digit",
//   },
//   [IDateFormat.DD_MM_YYYY_HH_MM]: {
//     month: "2-digit",
//     day: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: false,
//   },
//   [IDateFormat.DD_MM_YYYY_HH_MM_AMPM]: {
//     month: "2-digit",
//     day: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   },
//   [IDateFormat.DATE_TIME]: {
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//   },
//   [IDateFormat.DATE_ONLY]: {
//     year: "numeric",
//     month: "2-digit",
//     day: "numeric",
//   },
//   [IDateFormat.TIME_ONLY_AMPM]: {
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: true,
//   },
//   [IDateFormat.TIME_ONLY_AMPM_HH_MM]: {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   },
//   [IDateFormat.TIME_ONLY_24HRS]: {
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: false,
//   },
//   [IDateFormat.TIME_ONLY_HHMM]: {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: false,
//   },
// };
